import {
    REFRESH_WEBCHAT,
    REFRESH_WEBCHAT_FAILED,
    REFRESH_WEBCHAT_SUCCESS,
    HAND_OVER_TO_AGENT,
} from './constants';

/**
 * Create an action of type REFRESH_WEBCHAT_MESSAGE
 *
 * @export {function} sendWebchatMessage
 * @returns {Object} - Action of type REFRESH_WEBCHAT_MESSAGE
 */
export function refresh () {
    return {
        type: REFRESH_WEBCHAT,
    };
}

/**
 * Create an action of type REFRESH_WEBCHAT_MESSAGE_SUCCESS
 *
 * @export {function} sendWebchatMessageSuccess
 * @returns {Object} - Action of type REFRESH_WEBCHAT_MESSAGE_SUCCESS and the API data payload
 */
export function refreshWebchatSuccess (response) {
    return {
        type: REFRESH_WEBCHAT_SUCCESS,
        response,
    };
}

/**
 * Create an action of type REFRESH_WEBCHAT_MESSAGE_FAILED
 *
 * @export {function} sendWebchatMessageFailed
 * @returns {Object} - Action of type REFRESH_WEBCHAT_MESSAGE_FAILED and the API data payload
 */
export function refreshWebchatFailed (error, errorCode) {
    return {
        type: REFRESH_WEBCHAT_FAILED,
        error,
        errorCode,
    };

}
/**
 * Create an action handover to an agent
 *
 * @export {function} handOverToAgent
 * @returns {Object} - Action of type HAND_OVER_TO_AGENT
 */
 export const handOverToAgent = () => {
    return {
        type: HAND_OVER_TO_AGENT,
    };
};
